
Vue.component("iconfont", {
  mounted() {
  },
  props: {
      type: {
          type: String,
          default: ''
      },
      width: {
          type: String,
          default: '1em'
      },
      height: {
          type: String,
          default: '1em'
      },
      class_name: {
          type: String,
          default: ''
      },
  },
  template: `
  <svg :width="width" :height="height" :class="class_name"
      fill="currentColor" aria-hidden="true" focusable="false" class="iconfont" @click="$emit('click')">
      <use :xlink:href="'#'+type"></use>
  </svg>
  `,
});